import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import StudentRegisterPage from "@/pages/StudentRegisterPage";
import StudentGamePage from "@/pages/StudentGamePage";
import StudentResultsPage from "@/pages/StudentResultsPage";
import PublicLeaderboardPage from "@/pages/PublicLeaderboardPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import AdminQuestionsPage from "@/pages/AdminQuestionsPage";
import AdminUploadPage from "@/pages/AdminUploadPage";
import AdminStudentsPage from "@/pages/AdminStudentsPage";
import AdminSchoolsPage from "@/pages/AdminSchoolsPage";
import AdminAnalyticsPage from "@/pages/AdminAnalyticsPage";
import AdminSettingsPage from "@/pages/AdminSettingsPage";
import AdminEventsPage from "@/pages/AdminEventsPage";
import AdminLayout from "@/components/AdminLayout";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* root → student register */}
        <Route path="/" element={<Navigate to="/student/register" replace />} />

        {/* student-facing */}
        <Route path="/student/register" element={<StudentRegisterPage />} />
        <Route path="/student/play" element={<StudentGamePage />} />
        <Route path="/student/results" element={<StudentResultsPage />} />
        <Route path="/leaderboard" element={<PublicLeaderboardPage />} />

        {/* admin */}
        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route element={<AdminLayout />}>
          <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />
          <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
          <Route path="/admin/questions" element={<AdminQuestionsPage />} />
          <Route path="/admin/upload" element={<AdminUploadPage />} />
          <Route path="/admin/students" element={<AdminStudentsPage />} />
          <Route path="/admin/schools" element={<AdminSchoolsPage />} />
          <Route path="/admin/analytics" element={<AdminAnalyticsPage />} />
          <Route path="/admin/events" element={<AdminEventsPage />} />
          <Route path="/admin/settings" element={<AdminSettingsPage />} />
        </Route>

        <Route path="*" element={<Navigate to="/student/register" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
